import React from 'react'
import Slider from 'react-slick'

import ActivityVideo from './ActivityVideo'
import SlideImage from './SlideImage'
import SlideQuote from 'app/domains/common/ActivityQuote'
import { activitySliderSettings } from 'app/constants/sliderSettings'

import './styles.scss'
const bc = 'activity-view'

const UserActivityControlPanelCarousel = ({ activityVideoId }) => (
  <div className={bc}>
    <Slider {...activitySliderSettings} className={`${bc}__slider`}>
      <div>{activityVideoId ? <ActivityVideo /> : <SlideImage />}</div>
      <div>
        <SlideQuote />
      </div>
    </Slider>
  </div>
)

export default UserActivityControlPanelCarousel
